import LogRocket from "logrocket";

console.log("Initializing LogRocket");
export const logrocket = LogRocket.init(process.env.REACT_APP_LOG_ROCKET_PROJECT_ID);

// Identify the LogRocket user
export const setIdentity = (identity) => {
  LogRocket.identify(identity);
};
